import React, { FC } from 'react';

import { Box, Divider, Typography } from '@mui/material';

interface IconCardHeaderProps {
  icon: React.ElementType;
  title: string;
}

const IconCardHeader: FC<IconCardHeaderProps> = ({ icon: Icon, title }) => (
  <>
    <Box display="flex" alignItems="center" mb={2}>
      <Icon color="primary" sx={{ mr: 1 }} />
      <Typography variant="h6" fontWeight="600">
        {title}
      </Typography>
    </Box>
    <Divider sx={{ mb: 1 }} />
  </>
);

export default IconCardHeader;
